import styled from 'styled-components'

export const ConversationOrderSummarySectionHeaderStyled = styled.div`
  padding: ${(props) => props.theme.space.medium};
`
